<div class="wrapper">
  <div class="form-row">
    <div class="field-group">
      <input
        type="text"
        id="firstName"
        [(ngModel)]="details!.firstName"
        #firstName="ngModel"
        required
        maxlength="50"
        name="firstName"
        placeholder="First Name *"
        pattern="^(?!['. \-])(?!.*--)[a-zA-Zà-žÀ-Žä-üÄ-ÜëËïÏöÖüÜÿŸçÇñÑ .'\-]+$"
        autocomplete="given-name"
      />
      <span
        *ngIf="firstName.errors?.['required'] && (firstName.dirty || firstName.touched)"
        >First Name is required</span
      >
      <span
        *ngIf="firstName.errors?.['pattern'] && (firstName.dirty || firstName.touched)"
        >Invalid character in first name</span
      >
    </div>

    <div class="field-group">
      <input
        type="text"
        id="lastName"
        [(ngModel)]="details!.lastName"
        #lastName="ngModel"
        required
        maxlength="50"
        name="lastName"
        placeholder="Last Name *"
        pattern="^(?!['. \-])(?!.*--)[a-zA-Zà-žÀ-Žä-üÄ-ÜëËïÏöÖüÜÿŸçÇñÑ .'\-]+$"
        autocomplete="family-name"
      />
      <span
        *ngIf="lastName.errors?.['required'] && (lastName.dirty || lastName.touched)"
        >Last Name is required</span
      >
      <span
        *ngIf="lastName.errors?.['pattern'] && (lastName.dirty || lastName.touched)"
        >Invalid character in last name</span
      >
    </div>
  </div>

  <div class="form-row">
    <div class="field-group">
      <input
        type="text"
        id="email"
        [(ngModel)]="details!.email"
        #email="ngModel"
        required
        maxlength="100"
        name="email"
        placeholder="Email *"
        pattern="^(?!.*--)(?![+\-])[A-Za-z0-9._+\-]+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,63}$"
        autocomplete="email"
      />
      <span *ngIf="email.errors?.['required'] && (email.dirty || email.touched)"
        >Email is required</span
      >
      <span *ngIf="email.errors?.['pattern'] && (email.dirty || email.touched)"
        >Invalid email</span
      >
      <span *ngIf="serverError==='invalid-email' && serverErrorEmail===details!.email"
        >Invalid email</span
      >
    </div>
    <div class="field-group">
      <select
        id="country"
        [(ngModel)]="details!.country"
        #country="ngModel"
        name="country"
        required
        [ngClass]="{ 'select-placeholder': !details?.country }"
      >
        <option [value]="undefined" disabled selected hidden>Country *</option>
        <option
          *ngFor="let countryOption of countries"
          [value]="countryOption.name"
        >
          {{ countryOption.name }}
        </option>
      </select>
      <span *ngIf="country.invalid && (country.dirty || country.touched)">
        Country is required
      </span>
    </div>
  </div>

  <div class="form-row">
    <div class="field-group">
      <input
        type="text"
        id="position"
        [(ngModel)]="details!.position"
        #position="ngModel"
        maxlength="100"
        name="position"
        placeholder="Position"
        pattern="^(?!['. \-])(?!.*--)[a-zA-Z0-9à-žÀ-Žä-üÄ-ÜëËïÏöÖüÜÿŸçÇñÑ& .,'\-]+$"
        autocomplete="organization-title"
      />
      <span
        *ngIf="position.errors?.['pattern'] && (position.dirty || position.touched)"
        >Invalid character in position</span
      >
    </div>

    <div class="field-group">
      <input
        type="text"
        id="company"
        [(ngModel)]="details!.company"
        #company="ngModel"
        maxlength="100"
        name="company"
        placeholder="Company"
        pattern="^(?!['. \-])(?!.*--)[a-zA-Z0-9à-žÀ-Žä-üÄ-ÜëËïÏöÖüÜÿŸçÇñÑ& .,'\-]+$"
        autocomplete="organization"
      />
      <span
        *ngIf="company.errors?.['pattern'] && (company.dirty || company.touched)"
        >Invalid character in company</span
      >
    </div>
  </div>
</div>

